import contactsPhoto from "../../photos/Alisa_contacts_photo.png";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaFacebookSquare } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaRegEnvelope } from "react-icons/fa6";
import { FaBluesky } from "react-icons/fa6";

export const Contacts = () => {
	return (
		<section className="container contacts">
			<div className="contacts__content">
				<div className="contacts__info">
					<h1 className="contacts__info-title">
						University of Delaware
					</h1>
					<p>
						<br />
						Joseph R. Biden, Jr. School of Public Policy and
						Administration
						<br />
						180D Graham Hall
						<br />
						Newark, DE 19716
						<br />
						<a
							className="contacts__social-link"
							href="mailto:alisam@udel.edu"
							alt="Mail"
							aria-label="Mail"
						>
							<FaRegEnvelope />
						</a>
					</p>
					<p>
						<br />
						<br />
						Associate Professor and Director, MPA Program
						<br />
						Senior Faculty Fellow, Institute for Public
						Administration
					</p>
					<div className="contacts__social">
						<a
							href="https://www.linkedin.com/in/alisa-moldavanova-7197442/"
							className="contacts__social-link"
							target="_blank"
							rel="noopener noreferrer"
						>
							<FaLinkedin />
						</a>
						<a
							href="https://www.instagram.com/ladycosm/?hl=en"
							className="contacts__social-link"
							target="_blank"
							rel="noopener noreferrer"
						>
							<FaInstagram />
						</a>
						<a
							href="https://www.facebook.com/alisa.moldavanova"
							className="contacts__social-link"
							target="_blank"
							rel="noopener noreferrer"
						>
							<FaFacebookSquare />
						</a>

						<a
							href="https://x.com/Sustain_Scholar"
							className="contacts__social-link"
							target="_blank"
							rel="noopener noreferrer"
						>
							<FaXTwitter />
						</a>
						<a
							href="https://bsky.app/profile/sustainscholar.bsky.social"
							className="contacts__social-link"
							target="_blank"
							rel="noopener noreferrer"
						>
							<FaBluesky />
						</a>
					</div>
				</div>
				<div className="contacts__photo">
					<img
						className="contacts__photo-style"
						src={contactsPhoto}
						alt="alisa_moldovanova_photo_from_exibition"
					/>
				</div>
			</div>
		</section>
	);
};
